import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearch = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.1441 8.14742C16.1441 9.90904 15.5685 11.5558 14.6093 12.8579L19.444 17.7215C19.9428 18.181 19.9428 18.9852 19.444 19.4448C18.9836 19.9426 18.1778 19.9426 17.7173 19.4448L12.8442 14.5812C11.5396 15.5769 9.88963 16.113 8.16293 16.113C3.75027 16.113 0.181763 12.5515 0.181763 8.14742C0.181763 3.78166 3.75027 0.181816 8.16293 0.181816C12.5372 0.181816 16.1441 3.78166 16.1441 8.14742ZM8.16293 13.6621C11.1942 13.6621 13.6884 11.2111 13.6884 8.14742C13.6884 5.12202 11.1942 2.63277 8.16293 2.63277C5.09325 2.63277 2.63751 5.12202 2.63751 8.14742C2.63751 11.2111 5.09325 13.6621 8.16293 13.6621Z",
		fill: "currentColor"
	})
});
export default SvgSearch;
